<template>
  <div class="objects-front">
    <vue-headful
      title="IPUniversity"
      description="Цифровая платформа обмена знаниями и управления авторскими правами"/>
    <router-view name="form"/>
    <keep-alive>
      <router-view/>
    </keep-alive>
    <router-view name="stat"/>
    <page-footer/>
  </div>
</template>

<script>
import PageFooter from '../PageFooter';

export default {
  components: { PageFooter },
};
</script>

<style scoped>
h3 {
  font-weight: normal;
  margin: 23px auto 17px;
  font-size: 19px;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Frontpage.vue